document.addEventListener('DOMContentLoaded', () => {
	function initSlider({ carousel, prevBtn, nextBtn }) {
		if (!carousel || $(carousel).hasClass('slick-initialized')) return; // already inited or missing

		$(carousel).slick({
			infinite: true,
			speed: 350,
			slidesToScroll: 1,
			arrows: true,
			variableWidth: true,
			prevArrow: $(prevBtn || '<button type="button" class="slick-prev"></button>'),
			nextArrow: $(nextBtn || '<button type="button" class="slick-next"></button>'),
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						variableWidth: false,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						variableWidth: false,
					},
				},
			],
		});
	}


	const featureWrappers = document.querySelectorAll('.content-section__lh-explore');

	if (!featureWrappers.length) {
		console.warn('No feature wrappers found for slider initialization');
		return;
	}

	featureWrappers.forEach((wrapper) => {
		const carousel = wrapper.querySelector('.hub-items');
		const prevBtn = wrapper.querySelector('.hub-items-button-prev');
		const nextBtn = wrapper.querySelector('.hub-items-button-next');

		initSlider({ carousel, prevBtn, nextBtn });
	});
});
